module.exports = __webpack_public_path__ + "img/founder1.2cc60a2d.png";